module.exports = __webpack_public_path__ + "img/jf_home_00.80ff6694.jpg";